import {
  GET_SKUFORREPRINT_REQUEST,
  GET_SKUFORREPRINT_SUCCESS,
  GET_SKUFORREPRINT_FAILURE,
  REPRINT_REQUEST,
  REPRINT_SUCCESS,
  REPRINT_FAILURE,
  SUID_REPRINT_REQUEST,
  SUID_REPRINT_SUCCESS,
  SUID_REPRINT_FAILURE,
} from "./reprintTypes";
import axios from "axios";
import Config from "../../config/index";

let baseUrl = Config.baseUrl;

const getSkuForReprintRequest = () => {
  return {
    type: GET_SKUFORREPRINT_REQUEST,
  };
};

const getSkuForReprintSuccess = (payload) => {
  return {
    type: GET_SKUFORREPRINT_SUCCESS,
    payload: payload,
  };
};

const getSkuForReprintFailure = (error) => {
  return {
    type: GET_SKUFORREPRINT_FAILURE,
    payload: error,
  };
};

const getSkuForReprint = (grnNumber, grnLineNumber, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSkuForReprintRequest());
    let url = `${baseUrl}/common/get_suid_by_grn?grnNumber=${grnNumber}&grnLineNumber=${grnLineNumber}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSkuForReprintSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSkuForReprintFailure(err.message));
      });
  };
};

const reprintRequest = () => {
  return {
    type: REPRINT_REQUEST,
  };
};

const reprintSuccess = (payload) => {
  return {
    type: REPRINT_SUCCESS,
    payload: payload,
  };
};

const reprintFailure = (error) => {
  return {
    type: REPRINT_FAILURE,
    payload: error,
  };
};

const reprint = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(reprintRequest());
    let url = `${baseUrl}/common/reprint_sku`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(reprintSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(reprintFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const getSuidForReprintRequest = () => {
  return {
    type: SUID_REPRINT_REQUEST,
  };
};

const getSuidForReprintSuccess = (payload) => {
  return {
    type: SUID_REPRINT_SUCCESS,
    payload: payload,
  };
};

const getSuidForReprintFailure = (error) => {
  return {
    type: SUID_REPRINT_FAILURE,
    payload: error,
  };
};

const getSuidForReprint = (
  itemId,
  searchde,
  warehouseSelected,
  concatenatedLocation,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSuidForReprintRequest());
    let url = `${baseUrl}/suid/by_item?itemId=${itemId}&search=${searchde}&warehouseCode=${warehouseSelected}&locationCode=${concatenatedLocation}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSuidForReprintSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSuidForReprintFailure(err.message));
      });
  };
};

export { getSkuForReprint, reprint,getSuidForReprint};
